import React, { useEffect } from 'react';
import './styles.scss';
import SpecialRoleInfo from './components/SpecialRoleInfo/SpecialRoleInfo';
import GeneralInfoBlock from './components/GeneralInfoPart/GeneralPartInfo';
import { fetchHomePageData } from 'store/homePage/homePageOperations';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from 'components/PageLoader2/PageLoader2';
import { onDSLogin } from 'pages/Settings/components/WorkShiftsHeader/WorkShiftsHeader';
import { hasPermissionsFor, checkUserRole } from 'helpers/_helpers';
import { useSearchParams } from 'react-router-dom';
import { authorizeToDocuSign } from './components/apiCalls';
import { fetchPersonalProfile } from 'store/personalProfile/personalProfileOperations';

const HomePage = () => {
  const data = useSelector((state) => state.homePage.homePage);
  const user = useSelector((store) => store.personalProfile.user);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const docuSignAuthorization = searchParams.get('code');

  useEffect(() => {
    if (docuSignAuthorization) {
      authorizeToDocuSign()
        .then((e) => {
          dispatch(fetchPersonalProfile());
        })
        .catch((e) => {});
    }
  }, [docuSignAuthorization]);

  useEffect(() => {
    dispatch(fetchHomePageData());
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const userName = user?.profile?.fullName.split(' ')[0] || user.username;
  const isDocuSignUnauthorized = user?.organization?.docuSignStatus === 'unauthorized';
  const docuSignPermissions =
    hasPermissionsFor('materialCertification') || checkUserRole('Super Admin');

  return (
    <>
      {!data || !user ? (
        <PageLoader loading>
          <div />
        </PageLoader>
      ) : (
        <>
          {!!data && !!user && (
            <section className="section">
              <div className="header-title">
                <h3 className="main-container-title">Hi, {userName}!</h3>
                {docuSignPermissions && isDocuSignUnauthorized && (
                  <span className="primary-text" onClick={onDSLogin}>
                    Login to DocuSign
                  </span>
                )}
              </div>
              <div className="main-container-information">
                <GeneralInfoBlock
                  user={user}
                  data={data}
                  isDocuSignUnauthorized={isDocuSignUnauthorized}
                  docuSignPermissions={docuSignPermissions}
                />
                <SpecialRoleInfo user={user} data={data} />
              </div>
            </section>
          )}
        </>
      )}
    </>
  );
};
export default HomePage;
